import * as React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';

interface IPlanFirmFormProps {
    name: string;
    onChange: (e: any) => void;
}

const PlanFirmForm = (props: IPlanFirmFormProps) => {
    return (
        <form>
            <FormGroup>
                <ControlLabel>{Translate('plan-firms/modal/form/input-label/name')}</ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="name"
                    value={props.name ? props.name : ''}
                    placeholder={Translate('plan-firms/form/input-label/placeholder/enter-name')}
                    onChange={props.onChange}
                />
            </FormGroup>
        </form>
    );
};

export default PlanFirmForm;
